import AppContext from "@/AppContext";
import { useContentPreferences } from "@/hooks/content_preferences";
import { useContext } from "react";
import toast from "react-hot-toast";
import ContentPreferenceItem from "../items/ContentPreferenceItem";
import Spinner from "../Spinner";
import { Button } from "../ui/button";

function UserContentTypes() {
  const context = useContext(AppContext);
  const { preferences, toggleUserPreference, updatePreferences, isUpdating } =
    useContentPreferences();

  const save = async (evt) => {
    evt.preventDefault();

    try {
      await updatePreferences();
      toast.success("Preferences updated!");
    } catch (error) {
      toast.error("Failed to save preferences. Please try again!");
    }
  };

  const renderContentTypeList = () =>
    context.state.contentTypes.map((contentType) => (
      <ContentPreferenceItem
        key={`content-preference-${contentType.uuid}`}
        name={contentType.name}
        uuid={contentType.uuid}
        selected={preferences.includes(contentType.uuid)}
        onChange={() => toggleUserPreference(contentType.uuid)}
      />
    ));

  return (
    <>
      <p className='mb-4 text-lg font-semibold text-white'>
        Content Preferences
      </p>
      <form onSubmit={save}>
        <div className='flex flex-wrap gap-1'>{renderContentTypeList()}</div>
        <Button type='submit' className='mt-5'>
          {isUpdating && <Spinner />}
          {isUpdating ? "Updating..." : "Save Changes"}
        </Button>
      </form>
    </>
  );
}

export default UserContentTypes;
